<app-upload-box
  [options]="uploadBoxOptions"
  [showFileList]="false"
  image="assets/images/upload-file.png"
  (complete)="onUploadComplete($event)"
  class="mt-3"
  *ngIf="!isMaxFilesReached"
></app-upload-box>

<div class="alert alert-secondary-warning" *ngIf="isMaxFilesReached">
  <i class="fal fa-info-circle alert-icon"></i>
  <div class="alert-content">
    <ng-container i18n>Maximum number of files reached.</ng-container>
  </div>
</div>

<div class="border bg-white rounded overflow-hidden mt-3">
  <div class="p-3 border-bottom d-flex">
    <app-table-search
      i18n-inputTooltip
      inputTooltip="Enter document name you want to search for"
      [ctrl]="searchCtrl"
    ></app-table-search>
    <app-cancel-filters
      [isFiltering]="searchCtrl.value"
      (clear)="searchCtrl.reset()"
      class="ml-auto"
    ></app-cancel-filters>
  </div>
  <mat-table #table matSort [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> <ng-container i18n>Title</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="bytes">
      <mat-header-cell *matHeaderCellDef mat-sort-header> <ng-container i18n>Size</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.bytes | fileSize }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="preBooking">
      <mat-header-cell *matHeaderCellDef> <ng-container i18n>Pre Booking</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">
        <app-form-switch
          [inline]="true"
          i18n-matTooltip
          matTooltip="Do you really want to share this information before booking confirmation?"
          [checked]="element.preBooking"
          (valueChange)="onTogglePreBooking(element, $event)"
        ></app-form-switch>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="postBooking">
      <mat-header-cell *matHeaderCellDef> <ng-container i18n>Post Booking</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">
        <app-form-switch
          [inline]="true"
          i18n-matTooltip
          matTooltip="Do you really want to share this information after booking confirmation?"
          [checked]="element.postBooking"
          (valueChange)="onTogglePostBooking(element, $event)"
        ></app-form-switch>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="postCheckin">
      <mat-header-cell *matHeaderCellDef> <ng-container i18n>Post Checkin</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">
        <app-form-switch
          [inline]="true"
          i18n-matTooltip
          matTooltip="Do you really want to share this information after guest checkin?"
          [checked]="element.postCheckin"
          (valueChange)="onTogglePostCheckin(element, $event)"
        ></app-form-switch>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="rentals">
      <mat-header-cell *matHeaderCellDef class="flex-2"> <ng-container i18n>Rentals</ng-container></mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        (click)="onChangeRentals(element)"
        class="flex-2 clickable"
        matTooltip="Click to edit linked rentals"
        i18n-matTooltip
      >
        <a href="javascript:;" *ngIf="element.linkedRentals?.length" class="text-truncate">
          <span *ngFor="let rentalId of element.linkedRentals; let last = last">
            {{ rentalId | rentalName | async }}
            <ng-container *ngIf="!last">, </ng-container>
          </span>
        </a>
        <a href="javascript:;" *ngIf="!element.linkedRentals?.length" i18n>All Rentals</a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef> <ng-container i18n>Actions</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element" class="d-flex gap-3">
        <a
          href="javascript:;"
          (click)="onDelete(element)"
          i18n-matTooltip
          matTooltip="Delete this file"
          class="text-danger"
          ><i class="cs-icon cs-icon-trash"></i
        ></a>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <app-empty-table type="AIDocuments" *ngIf="!dataSource.data?.length"></app-empty-table>

  <mat-paginator2
    #paginator
    [length]="dataSource?.data?.length"
    [pageSizeOptions]="[5, 10, 20, 50]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator2>
</div>
